import { $t } from "@/lib/i18nHelpers";

export default [
  { stusab: "AL", state_name: $t("Alabama") },
  { stusab: "AK", state_name: $t("Alaska") },
  { stusab: "AS", state_name: $t("American Samoa") },
  { stusab: "AZ", state_name: $t("Arizona") },
  { stusab: "AR", state_name: $t("Arkansas") },
  { stusab: "CA", state_name: $t("California") },
  { stusab: "CO", state_name: $t("Colorado") },
  { stusab: "CT", state_name: $t("Connecticut") },
  { stusab: "DE", state_name: $t("Delaware") },
  { stusab: "DC", state_name: $t("District of Columbia") },
  { stusab: "FL", state_name: $t("Florida") },
  { stusab: "GA", state_name: $t("Georgia") },
  { stusab: "GU", state_name: $t("Guam") },
  { stusab: "HI", state_name: $t("Hawaii") },
  { stusab: "ID", state_name: $t("Idaho") },
  { stusab: "IL", state_name: $t("Illinois") },
  { stusab: "IN", state_name: $t("Indiana") },
  { stusab: "IA", state_name: $t("Iowa") },
  { stusab: "KS", state_name: $t("Kansas") },
  { stusab: "KY", state_name: $t("Kentucky") },
  { stusab: "LA", state_name: $t("Louisiana") },
  { stusab: "ME", state_name: $t("Maine") },
  { stusab: "MD", state_name: $t("Maryland") },
  { stusab: "MA", state_name: $t("Massachusetts") },
  { stusab: "MI", state_name: $t("Michigan") },
  { stusab: "MN", state_name: $t("Minnesota") },
  { stusab: "MS", state_name: $t("Mississippi") },
  { stusab: "MO", state_name: $t("Missouri") },
  { stusab: "MT", state_name: $t("Montana") },
  { stusab: "NE", state_name: $t("Nebraska") },
  { stusab: "NV", state_name: $t("Nevada") },
  { stusab: "NH", state_name: $t("New Hampshire") },
  { stusab: "NJ", state_name: $t("New Jersey") },
  { stusab: "NM", state_name: $t("New Mexico") },
  { stusab: "NY", state_name: $t("New York") },
  { stusab: "NC", state_name: $t("North Carolina") },
  { stusab: "ND", state_name: $t("North Dakota") },
  { stusab: "MP", state_name: $t("Northern Mariana Islands") },
  { stusab: "OH", state_name: $t("Ohio") },
  { stusab: "OK", state_name: $t("Oklahoma") },
  { stusab: "OR", state_name: $t("Oregon") },
  { stusab: "PA", state_name: $t("Pennsylvania") },
  { stusab: "PR", state_name: $t("Puerto Rico") },
  { stusab: "RI", state_name: $t("Rhode Island") },
  { stusab: "SC", state_name: $t("South Carolina") },
  { stusab: "SD", state_name: $t("South Dakota") },
  { stusab: "TN", state_name: $t("Tennessee") },
  { stusab: "TX", state_name: $t("Texas") },
  { stusab: "UM", state_name: $t("U.S. Minor Outlying Islands") },
  { stusab: "VI", state_name: $t("U.S. Virgin Islands") },
  { stusab: "UT", state_name: $t("Utah") },
  { stusab: "VT", state_name: $t("Vermont") },
  { stusab: "VA", state_name: $t("Virginia") },
  { stusab: "WA", state_name: $t("Washington") },
  { stusab: "WV", state_name: $t("West Virginia") },
  { stusab: "WI", state_name: $t("Wisconsin") },
  { stusab: "WY", state_name: $t("Wyoming") },
];
